/**
 * A Clerk rejection always carries an error code; a request that never reached
 * Clerk throws a bare `TypeError` (on iOS Safari, "Load failed"). Only the first
 * is ours to answer for, so the second must not page anyone at error level.
 */
export const isDroppedRequest = (err: any): boolean =>
  !err?.errors?.[0]?.code && err instanceof TypeError;
